import { NextPage } from 'next';
import ContactPage from '@sy/app-client/src/ssrAdapter/pages/ContactPage';

import MarketingTemplate from '~/components/templates/MarketingTemplate';
import buildMetatadata from '~/utils/buildMetadata';
import { getMarketingNavigation } from '~/utils/getNavigation';
import useIHeartTracking from '@sy/app-client/src/ssrAdapter/components/useIHeartTracking';
import { translate, buildGetServerSideProps } from '../getServerSideProps';
import type { CommonContext, InferProps } from '../getServerSideProps';

const Contact: NextPage<InferProps<typeof getServerSideProps>> = ({
	navigation,
	user,
}) => {
	useIHeartTracking({
		action: 'registration',
	});
	return (
		<MarketingTemplate
			activePage="/contact"
			navigation={navigation}
			user={user}
		>
			<ContactPage />
		</MarketingTemplate>
	);
};

const customServerSideProps = async (context: CommonContext) => {
	const { featureFlags, locale, query } = context;

	return {
		props: {
			metadata: buildMetatadata({
				title: translate(locale, 'common.title.contact'),
			}),
			navigation: await getMarketingNavigation({ featureFlags, locale, query }),
		},
	};
};

export const getServerSideProps = buildGetServerSideProps({
	customServerSideProps,
	translationNamespaces: ['common', 'auth', 'landing', 'contact'],
});

export default Contact;
